module.exports = __webpack_public_path__ + "../resources/images/SkyCode_67-460a9d74a53155a90c09fee4e3fc2ff2.svg";